module.exports = __webpack_public_path__ + "img/welcome-parent-mode-1.3c1dc1d7.png";